import { withChildren } from '@builder.io/react';
import { builderElement } from '../../../builder/element-factories';
import { createBuilderModule } from '../../../builder';
import { CarouselSection } from './CarouselSection';

export default createBuilderModule(withChildren(CarouselSection), {
  name: 'CarouselSection',
  image: 'https://cdn.zappy.app/70bef4e8e2b54f2a55972f5c147e48c6.png',
  inputs: [
    {
      name: 'subheading',
      type: 'string',
      defaultValue: 'Section Subheading',
    },
    {
      name: 'heading',
      type: 'string',
      defaultValue: 'Section Heading',
    },
  ],
  defaultChildren: Array(3).fill(
    builderElement('BlockGridItem', {
      heading: 'Example heading',
      description: '<p>Example content...</p>',
      imageUrl:
        'https://res.cloudinary.com/zapier-media/image/upload/q_auto/f_auto/v1656512382/Blog/Generic/abstract-zaps_qpodgh.png',
    }),
  ),
});
